import { ErrorOutput } from '../../types';
import CoverageNotCompliant from './CoverageNotCompliant/CoverageNotCompliant';

const CoverageErrors = ({
  applicationErrors,
}: {
  applicationErrors?: ErrorOutput[];
}) => {
  return (
    <CoverageNotCompliant errors={applicationErrors || []}/>
  );
};

export default CoverageErrors;
